// extracted by mini-css-extract-plugin
export default {"mCard":"bC-z","image":"cC-z","imageNoBackground":"dC-z","imageHasCategory":"eC-z","fullWidth":"fC-z"};